import React, { Component } from 'react';

import { UTILITY_USER_ROLE_ADMIN } from 'common/utility/userRoles';

import { SCREEN_ID_UTILITY_PROFIT_ADMIN_MAPPING_HITLIST } from 'client/constants/screenIds';

import branch from 'client/core/branch';
import withTransitionHook from 'client/helpers/withTransitionHook';
import withScreenId from 'client/helpers/withScreenId';
import withScrollToTop from 'client/helpers/withScrollToTop';
import allowedUtilityRoles from 'client/helpers/allowedUtilityRoles';

import SrPartnerPageV2 from 'client/components/SrPartnerPageV2/SrPartnerPageV2';
import UPMappingHitlist from 'client/components/UPMappingHitlist/UPMappingHitlist';

import UtilityActivationActions from 'client/actions/UtilityActivation';
import UtilityTypeActions from 'client/actions/UtilityType';

@withTransitionHook
@allowedUtilityRoles({
  roles: [UTILITY_USER_ROLE_ADMIN],
  redirectUrl: '/login',
  addRedirectQueryParam: true,
})
@withScreenId(SCREEN_ID_UTILITY_PROFIT_ADMIN_MAPPING_HITLIST)
@withScrollToTop
@branch({
  currentUser: ['utilityUser'],
  utilityTypes: ['utilityActivations', 'types'],
})
class UtilityProfitMappingHitlist extends Component {
  static getPageMetadata = () => ({
    pageTitle: 'Mapping Dashboard | Utility Profit',
  });

  static fetchData(match, inject) {
    return Promise.all([
      UtilityActivationActions.getTypesList(inject),
      UtilityTypeActions.getList(inject),
    ]);
  }

  render() {
    const { currentUser, dispatch, utilityTypes } = this.props;

    const sortedUtilityTypes = [...(utilityTypes || [])].sort((a, b) => a.order - b.order);

    return (
      <SrPartnerPageV2
        navbarTitle="Mapping Dashboard"
        backUrl="/utility-profit/admin"
        redirectToLastLocation={false}
        maxWidth="1250px"
      >
        <UPMappingHitlist
          title="Unmapped Addresses"
          currentUser={currentUser}
          dispatch={dispatch}
          utilityTypes={sortedUtilityTypes}
        />
      </SrPartnerPageV2>
    );
  }
}

export default UtilityProfitMappingHitlist;
